export default class CSSLoader {
    public static async loadAll(filePaths): Promise<{}> {
        // setting default attributes
        filePaths.forEach(filePath => {
            const href = filePath;
            let attributes = {
                href: href,
                rel: "stylesheet"
            };

            // appending the stylesheet... just plain dom manipulations
            const styleSheet = document.createElement("link");
            for (const key in attributes) {
                styleSheet.setAttribute(key, attributes[key]);
            }
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(styleSheet);
        });
        return {};
    }
}
